import axios from "axios"

const detail = async id => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/api/service/${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    )
    return { payload: response.data }
  } catch (error) {
    return { error }
  }
}

export default detail
